angular.module("app.modalControllers", []).controller("ConfirmApplyConfigModalController", [
    '$scope',
    '$uibModalInstance',
    function ($scope, $modalInstance) {

        $scope.ok = function () {
            $modalInstance.close($scope.applyMessage);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
